<table>
    <thead>
        <tr>
            <th class="subtable short sortable" (click)="toOrderBy('1')" [appSort]="listaCultivosCatastro" data-order="desc" data-name="poligonoCatastro">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoCatastro.poligono' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('1')"></i>
              </div>
            </th>
            <th class="subtable short sortable" (click)="toOrderBy('2')" [appSort]="listaCultivosCatastro" data-order="desc" data-name="parcelaCatastro">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoCatastro.parcela' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('2')"></i>
              </div>
            </th>
            <th class="subtable short sortable" (click)="toOrderBy('3')" [appSort]="listaCultivosCatastro" data-order="desc" data-name="refCatastral">
              {{'mantenimientoCultivos.tabs.cultivos.cultivoCatastro.refCatastral' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('3')"></i>
              </div>
            </th>
            <th class="subtable action">
                <i class="fas fa-plus" *ngIf="campanyaHabilitada && (this.role === 'Administrador' || this.claims.includes('CAT_Ins'))"
                  (click)="new=true;editables=''" title="{{'mantenimientoCultivos.tabs.cultivos.cultivoCatastro.tituloNew' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-cultivo-catastro-new-edit class="component-in-row" *ngIf="new" [editable]="true" [campanyaHabilitada]="campanyaHabilitada" [cultivoId]="_cultivoId" (close)="new=$event"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-catastro-new-edit>
        <app-cultivo-catastro-new-edit class="component-in-row" *ngFor="let cultivoCatastro of listaCultivosCatastro" [campanyaHabilitada]="campanyaHabilitada" [cultivoCatastro]="cultivoCatastro" [editable]="cultivoCatastro === editables" [cultivoId]="_cultivoId"
        (refresh)="refresh($event)" (editableChanged)="editableChanged($event)" (pushMessage)="pushMessage.emit($event)">
        </app-cultivo-catastro-new-edit>
    </tbody>
    <tfoot *ngIf="!new && (!listaCultivosCatastro || (listaCultivosCatastro && listaCultivosCatastro.length < 1))">
        <tr>
          <td colspan="4">
            {{'global.noContent' | translate}}
          </td>
        </tr>
    </tfoot>
</table>
